import axios, { AxiosResponse } from "axios";
import { GADrawing, BladeModel, HubBand, OctaveBand, FanData } from "../utils/models";

let baseUrl = process.env.REACT_APP_API_URL;


//blademodel
export function createBladeModel(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/blademodel/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
                console.log(response)
            })
            .catch((err) => {
                if (err.response && err.response.status === 422) {
                    console.log("Validation error:", err.response.data);
                    // Handle validation errors here
                    reject({error: err.response.data});
                } else {
                    console.log("Other error:", err);
                    reject({error: err});
                }
            });
        });
}

export function updateBladeModel(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/blademodel/update`,
            method: "PUT",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                if (err.response && err.response.status === 422) {
                    console.log("Validation error:", err.response.data);
                    // Handle validation errors here
                    reject({error: err.response.data});
                } else {
                    console.log("Other error:", err);
                    reject({error: err});
                }
            });
        });
}

export function removeBladeModel(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/blademodel/remove`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getBladeModelAPI() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/blademodel`,
            method: "GET",
            headers: {
                Accept: "application/json"
            },
          })
            .then((response) => {
                console.log('--response---',response)
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

//hubdetails
export function createHubBand(formData:HubBand) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/hubdetails/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}
export function updateHubBand(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/hubdetails/update`,
            method: "PUT",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                if (err.response && err.response.status === 422) {
                    console.log("Validation error:", err.response.data);
                    // Handle validation errors here
                    reject({error: err.response.data});
                } else {
                    console.log("Other error:", err);
                    reject({error: err});
                }
            });
        });
}

export function removeHubBand(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/hubdetails/remove`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getHubBandAPI() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/hubdetails`,
            method: "GET",
            headers: {
                Accept: "application/json"
            },
          })
            .then((response) => {
                console.log('--response---',response)
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}


//GAdrawing
export function createGADrawing(formData:GADrawing) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/gadrawings/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function updateGADrawing(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/gadrawings/update`,
            method: "PUT",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                if (err.response && err.response.status === 422) {
                    reject({error: err.response.data});
                } else {
                    console.log("Other error:", err);
                    reject({error: err});
                }
            });
        });
}

export function removeGADrawing(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/gadrawings/remove`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getGADrawing() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/gadrawings`,
            method: "GET",
            headers: {
                Accept: "application/json"
            },
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}


//octaveband
export function createOctaveBand(formData:OctaveBand) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/octaveband/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function updateOctaveBand(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/octaveband/update`,
            method: "PUT",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                if (err.response && err.response.status === 422) {
                    reject({error: err.response.data});
                } else {
                    console.log("Other error:", err);
                    reject({error: err});
                }
            });
        });
}

export function removeOctaveBand(formData:BladeModel) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/octaveband/remove`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getOctaveBands() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/octaveband`,
            method: "GET",
            headers: {
                Accept: "application/json"
            },
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}


export function createFan(formData:FanData) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getOctaveBand(octaveBandID:string) {
    return new Promise<{ response: any }>((resolve, reject) =>
    {
        // axios({
        //     url: `${baseUrl}/api/octaveband/${octaveBandID}`,
        //     method: "GET",
        //     headers: {
        //         Accept: "application/json"
        //     }
        //   })
        //     .then((response) => {
        //         resolve({response: response.data})
        //     })
        //     .catch((err) => {
        //         console.error(err)
        //         reject({error: err})
        //     });
        // });
        resolve({response: {
            data: {
                "octaveBandID":"OB002",
                "fanDiameter":8.534,
                "numOfBlades":6,
                "rpm":120,
                "dB":[51.3, 59.7, 60.7, 63.8, 60.8, 60.8, 57.8, 55.2, 49.3, 39.4]
                }
            }
        });

    });
}


export const getCountAllFans = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/general/counts`,
      {
        headers: {
          Accept: "application/json"
        }
      }
    );

    console.log(response.data);
    return response.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getFanCountInProjects = async () => {
  try {
    console.log("Hihihih")
    const response = await axios.get(
      `${baseUrl}/api/general/countFanInProject`,
      {
        headers: {
          Accept: "application/json"
        }
      }
    );

    console.log(response.data);
    return response.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};